import { AiOutlineClose } from 'react-icons/ai';
import { ConferenceSchedule } from '../resources/data/itinerary-test-interfaces';
import Agenda from './Agenda';
import ItineraryHeader from './ItineraryHeader';
import VoiceItineraryAgenda from './VoiceItineraryAgenda';
import VoiceItineraryHeader from './VoiceItineraryHeader';
import Lottie from 'react-lottie-player';
import * as sparkIdle from '../assets/lotties/Spark_Idle.json';
import * as sparkError from '../assets/lotties/Spark_Error.json';
import * as sparkHappiness from '../assets/lotties/Spark_Happiness.json';
import * as sparkJoy from '../assets/lotties/Spark_Joy.json';
import * as sparkListening from '../assets/lotties/Spark_Listening.json';
import * as sparkWave from '../assets/lotties/Spark_Wave.json';
import * as sparkSad from '../assets/lotties/Spark_Sad.json';
import * as sparkResponding from '../assets/lotties/Spark_Responding.json';
import * as sparkConfused from '../assets/lotties/Spark_Confused.json';
import * as sparkInsight from '../assets/lotties/Spark_Insight.json';

interface ItineraryProps {
  qrCodeURL: string;
  itinerary: ConferenceSchedule;
  handleCloseItinerary: () => void;
}

const VoiceItinerary = ({
  qrCodeURL,
  itinerary,
  handleCloseItinerary,
}: ItineraryProps) => {
  return (
    <div
      className={`ItineraryContainer p-3 relative z-10 flex h-full w-full flex-col items-center gap-1 overflow-y-scroll rounded-xl bg-white bg-opacity-10`}
    >
      <div
        className=" absolute right-3 top-4  z-[51] hover:cursor-pointer"
        onClick={handleCloseItinerary}
      >
        <div className="RouteIcon relative flex h-8 w-8 items-center justify-center rounded-full bg-white p-2">
          <AiOutlineClose size={24} />
        </div>
      </div>
      <VoiceItineraryHeader qrCodeURL={qrCodeURL} />
      <VoiceItineraryAgenda itinerary={itinerary} />
    </div>
  );
};

export default VoiceItinerary;
